import React from "react";
import {Brands} from "@core-ui/utility";
import {Icon} from "../components/Icon";
import {IconContainerProps} from "../types";

const CrossBrandSVG = (
  <svg viewBox="0 0 33 33" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.039.661c8.836 0 16 7.164 16 16 0 8.837-7.164 16-16 16-8.837 0-16-7.163-16-16 0-8.836 7.163-16 16-16zm-.19 20.97c-1.321 0-2.31.993-2.31 2.32 0 1.32.991 2.31 2.31 2.31 1.32 0 2.3-.99 2.3-2.31 0-1.327-.978-2.32-2.3-2.32zm1.915-13.827h-3.84v11.568h3.84V7.804z"
      fill="#D00000"
      fillRule="evenodd"
    />
  </svg>
);

const brandIconSVGs = {
  [Brands.Athleta]: CrossBrandSVG,
  [Brands.Gap]: CrossBrandSVG,
  [Brands.GapFactoryStore]: CrossBrandSVG,
  [Brands.OldNavy]: CrossBrandSVG,
  [Brands.BananaRepublic]: CrossBrandSVG,
  [Brands.BananaRepublicFactoryStore]: CrossBrandSVG,
  crossBrand: CrossBrandSVG,
};

export const NotificationCriticalIcon = (
  props: IconContainerProps
): JSX.Element => <Icon {...props} brandIconSVGs={brandIconSVGs} />;
